/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ConfirmAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'



/** @type {import('Simple/types.js').View} */
export default function ConfirmAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/TreatmentPlans/Content/AcceptTreatmentAction/Content/Selection/ConfirmAction"
  
}) {
let selectedTreatmentPlanIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'treatment_plan_id',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaModalFooterAction
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 type="primary"
 onClick={onClick}
 marginLeft={dtSpaceXs}
 data="selected.treatment_plan_id"
 disabled={!selectedTreatmentPlanIdValueData}
 text="Continue"
/>
{children}
</React.Fragment>)
}